@if (isShowFooter) {
  <footer [ngClass]="{'pdf-Format':isFooterHidden}">
    <div [ngClass]="{'pdf-footer-body':isFooterHidden,'section-footer-body':!isFooterHidden}">
      @if (footerContent && footerContent.footerLinks) {
        <div class="container">
          <div class="container-logos">
            <div class="container-logos__chubb">
              @for (link of footerContent.logoInfo; track link) {
                <div>
                  @if ((link.partnerId === logoId)) {
                    <div>
                      <img class="container-logos__chubb-blue" [src]="blobURL + link.logoUrl">
                    </div>
                  }
                </div>
              }
            </div>
            <div class="container-logos__media">
              @for (item of footerContent.socialMediaRow; track item) {
                <div class="container-logos__media-item">
                  <a [href]="item.link" target="_blank">
                    <img [src]="blobURL + item.icon" [alt]="item.tooltip">
                  </a>
                </div>
              }
            </div>
          </div>
          <div class="container-links">
            <ul class="container-links__section">
              <li class="container-links__section-item">
                <label>&copy; {{year}} Chubb</label>
              </li>
              @for (link of footerContent.footerLinks; track link) {
                <li class="container-links__section-item">
                  @if ((link.URL !== '')) {
                    <a class="{{link.classId}}" href="{{link.URL}}"
                    target="_blank">{{link.text}}</a>
                  }
                  @if ((link.URL === '')) {
                    <a class="{{link.classId}}">{{link.text}}</a>
                  }
                </li>
              }
            </ul>
          </div>
          <div class="container-disclaimer">
            @for (item of footerContent.disclaimerInfo; track item) {
              <div>
                @if ((item.partnersEligible === partnerCode)) {
                  <div>
                    <p class="container-disclaimer__text">
                      @for (subItem of item.content; track subItem) {
                        <span>
                          @if (subItem.type === 'text') {
                            <label [innerHTML]="subItem.text"></label>
                          }
                          @if (subItem.type === 'link') {
                            <a href="{{subItem.URL}}" target="_blank">{{subItem.text}}</a>
                          }
                        </span>
                      }
                    </p>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </footer>
}